import { Download } from 'lucide-react';
import { Link } from 'react-router-dom';

import { RelativeTime } from '@/components/RelativeTime';
import { Badge } from '@/components/ui/badge';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import type { AdminImportDto } from '@/services/formTemplates';
import { EmptyBlock } from './EmptyBlock';

const COLUMN_COUNT = 6;

export function TemplateImportsTab({ imports }: { imports: AdminImportDto[] }) {
  return (
    <div className="space-y-4">
      <p className="text-sm text-muted-foreground">
        The last 50 imports, newest first. Staff imports are marked and left out of Performance.
      </p>

      <div className="rounded-lg border bg-card">
        <div className="overflow-x-auto">
          <Table>
            <TableHeader>
              <TableRow className="bg-muted/50">
                <TableHead>Date</TableHead>
                <TableHead className="text-center">Agency</TableHead>
                <TableHead className="text-center">Version</TableHead>
                <TableHead className="text-center">Published</TableHead>
                <TableHead className="text-center">Leads</TableHead>
                <TableHead className="text-center">Bookings</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {imports.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={COLUMN_COUNT} className="h-48 text-center">
                    <EmptyBlock
                      icon={Download}
                      title="No imports yet"
                      description="Once customers use this template, the last 50 show here."
                    />
                  </TableCell>
                </TableRow>
              ) : (
                imports.map((row, index) => (
                  <TableRow key={`${row.createdAtUtc}-${index}`}>
                    <TableCell className="whitespace-nowrap text-muted-foreground">
                      <RelativeTime date={row.createdAtUtc} className="cursor-default" />
                    </TableCell>
                    <TableCell className="text-center">
                      <span className="inline-flex flex-wrap items-center justify-center gap-2">
                        {row.agency === null ? (
                          <span className="text-muted-foreground italic">Deleted agency</span>
                        ) : (
                          <Link to={`/agencies/${row.agency.publicId}`} className="font-medium hover:underline">
                            {row.agency.name}
                          </Link>
                        )}
                        {row.byStaff && <Badge tone="neutral">Staff</Badge>}
                      </span>
                    </TableCell>
                    <TableCell className="text-center whitespace-nowrap">{`v${row.versionNo}`}</TableCell>
                    <TableCell className="text-center">
                      <Badge tone={row.published ? 'success' : 'neutral'}>{row.published ? 'Yes' : 'No'}</Badge>
                    </TableCell>
                    <TableCell className="text-center tabular-nums">{row.leads}</TableCell>
                    <TableCell className="text-center tabular-nums">{row.bookings}</TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </div>
      </div>
    </div>
  );
}
